export const dateString = (stringDate: string): string => {
  return new Date(stringDate).toDateString();
};
